import { FaShareAlt } from 'react-icons/fa';
import { SocialsViewMain } from '../Components/SocialsViewMain';

export const SocialsModule = () => [{
    views: 'PRIVATE', path: '/dashboard/redes', component: <SocialsViewMain />,
    roles: null, permissions: null, label: 'Redes', icon: <FaShareAlt />,
    displayInHeader: false, displayInFooter: false, displayInSidebar: true,
    isBlockedWhenLogged: false,
}];
